import { initials } from '@/components/design';
import type { Match } from '@/data/types';

interface Props {
  match: Match;
  onPick: (winnerId: string) => void;
  disabled?: boolean;
}

export function ScoreWinnerOnly({ match, onPick, disabled }: Props) {
  if (!match.playerAId || !match.playerBId) {
    return <p className="t-small t-mute">Не оба игрока определены.</p>;
  }

  const renderBtn = (id: string, name: string | null) => (
    <button
      className="score-btn"
      disabled={disabled}
      onClick={() => onPick(id)}
      style={{ flexDirection: 'row', justifyContent: 'flex-start', padding: 14 }}
    >
      <div className="av" style={{ marginRight: 12 }}>
        {initials(name ?? '?')}
      </div>
      <span style={{ fontSize: 15, fontWeight: 500 }}>{name}</span>
    </button>
  );

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      <div className="t-eyebrow">Победитель</div>
      {renderBtn(match.playerAId, match.playerAName)}
      {renderBtn(match.playerBId, match.playerBName)}
    </div>
  );
}
